// The typed client for api.biblestandard.app, generated from the API's own OpenAPI file
// (src/api/openapi.json, vendored from biblestandard-api; `npm run api:types` regenerates
// schema.d.ts). A route or shape the API changes fails typecheck here.
import createClient from "openapi-fetch";
import type { paths } from "./schema";

/**
 * Unset: the app runs on the built-in prototype data (src/data/mock.ts). Set (e.g.
 * http://localhost:8787 or https://api.biblestandard.app): the app talks to that API.
 */
export const API_URL: string | undefined = import.meta.env.VITE_API_URL || undefined;

/**
 * Where requests go. In `vite dev` the dev server proxies /v1 to API_URL (vite.config.ts), so the
 * session cookie is same-origin; a built app calls the API directly (the cookie is shared on
 * biblestandard.app in staging and production).
 */
export const apiBase = (): string => (import.meta.env.DEV && typeof location !== "undefined" ? location.origin : (API_URL ?? "http://api.invalid"));

export type ApiClient = ReturnType<typeof createApi>;

export function createApi(opts: { baseUrl: string; fetch?: typeof fetch; headers?: Record<string, string> }) {
  return createClient<paths>({
    baseUrl: opts.baseUrl,
    credentials: "include",
    ...(opts.fetch ? { fetch: opts.fetch } : {}),
    ...(opts.headers ? { headers: opts.headers } : {}),
  });
}
